import { render, staticRenderFns } from "./ThankPage.vue?vue&type=template&id=624d70df&scoped=true&"
import script from "./ThankPage.vue?vue&type=script&lang=js&"
export * from "./ThankPage.vue?vue&type=script&lang=js&"
import style0 from "./ThankPage.vue?vue&type=style&index=0&id=624d70df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d70df",
  null
  
)

export default component.exports